<nav class="navbar">
  <div class="navbar-container">
    <div class="navbar-left">
      <div class="navbar-toggle-space" aria-hidden="true"></div>
      <a href="#" class="navbar-logo"><img src="assets/header.svg" alt="Logo"></a>
    </div>

    <div class="user-section">
      <span class="user-name">{{userName}}</span>
      <mat-icon class="user-icon">person</mat-icon>
    </div>
  </div>
</nav>
